import styled from 'styled-components';
export const DownloadAppSectionStyled = styled.div`
  position: relative;
  border-radius: 8px;
  padding: 16px;
  color: ${(props) => props.theme.color.white};
  width: 100%;
  background: linear-gradient(
    90deg,
    ${(props) => props.theme.colors.primary.green['700']} 0%,
    ${(props) => props.theme.colors.primary.green['400']} 100%
  );
  .title {
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 8px;
  }
  .countryCodeInputWrapper {
    display: flex;
    gap: 16px;
    .countryCodeInputInnerWrapper{
      direction: ltr;
    }
    .input-group {
      &:hover {
        border-color: ${(props) => props.theme.colors.primary.green['700']};
      }
      .country-div {
        align-items: flex-end;
        .dropdown-border{
          padding-bottom: 2px;
          .country-dropdown-toggle {
            z-index: 0;
          }
        }
        .form-floating{
          overflow: hidden;
          .country-dropdown-textbox {
            margin: 0px;
            background: transparent;
            color: ${(props) => props.theme.color.white};
          }
          &>label {
            top: 6px;
            color: ${(props) => props.theme.color.white};
            &::after {
              background: transparent;
            }
          }
        }
      }
    }
  }
  .submitCTA {
    color: ${(props) => props.theme.colors.primary.green['700']} !important;
    border-color: ${(props) => props.theme.color.white} !important;
    background: ${(props) => props.theme.color.white} !important;
    padding: 14px 48px;
    &:disabled {
      color: ${(props) => props.theme.colors.primary.green['700']} !important;
      border-color: ${(props) => props.theme.color.white} !important;
      background: ${(props) => props.theme.color.white} !important;
      opacity: 30%;
    }
  }
  .app-icon-wrapper {
    display: flex;
    gap: 12px;
    padding: 16px 20px 8px 0px;
    margin-top: 24px;    
  }

 .hand-mobile-img-wrappoer {
    position: absolute;
    bottom: 0;
    right: 0;
  }

  @media (max-width: 850px) {
    .hand-mobile-img-wrappoer {
    bottom: 8px;
    img {
        margin-right: -16px !important;
        width: 85%;
      }
    }
  }
  
  @media (max-width: 767px) {
    .app-icon-wrapper {
      margin: 0px;
    }
  }

  &.rtl {
    .hand-mobile-img-wrappoer {
      left: 0;
      right: auto;
    }
    .countryCodeInputWrapper {
      .form-floating {
        & > label {
          text-align: right;
          width: 100%;
        }
        .form-control:focus ~ label,
        .form-control:not(:placeholder-shown) ~ label {
          display: none;
        }
        .country-dropdown-textbox {
          direction: rtl;
        }
      }
      .invalid-error {
        direction: rtl;
      }
    }
  }
`;
